import _ from 'lodash'
import moment from 'moment'

export const prepareRequestData = (schema, values) => {
    let data = {};
    let tmpData = {};
    if (schema && schema.filter(e => e.type === 'file' || e.type === 'camera').length > 0) {
        const formData = new FormData()
        schema.map(s => {
            let val = parseReqData(s, values)
            if(s.type === 'camera' && typeof val == 'string'){
                val = DataURIToBlob(val)
                formData.append(s.modal[0], new File([val], "live.png"))
            }else{
                formData.append(s.modal[0], val)
            }
        })
        data.formData = formData
    }else{
        schema.map(s => {
            let val = parseReqData(s, values)
            tmpData = s.modal.reverse().reduce((res, key) => ({[key]: res}), val);
            _.merge(data, tmpData)
            console.log(val,data,tmpData)
            if(s.checkBox){
                tmpData = s.checkBox.modal.reverse().reduce((res, key) => ({[key]: res}), values[s.checkBox.name])
                _.merge(data, tmpData)
            }
        })
    }
    return data
}

let DataURIToBlob = (dataURI) => {
    const splitDataURI = dataURI.split(',')
    const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
    const mimeString = splitDataURI[0].split(':')[1].split(';')[0]

    const ia = new Uint8Array(byteString.length)
    for (let i = 0; i < byteString.length; i++)
        ia[i] = byteString.charCodeAt(i)

    return new Blob([ia], { type: mimeString })
}

let parseReqData = (s, values) => {
    let val = null
    switch(s.type){
        case 'text':
            val = s.rules.numeric ? parseInt(values[s.name]) : values[s.name];
            break;
        case 'time':
            let time = moment(String(values[s.name]))
            val = time.isValid ? time.format(s.format): null;
            break;
        case 'date':
            let date = moment(String(values[s.name]))
            val = date.isValid() ? date.format(s.format) : null;
            break;
        case 'select':
            val = values[s.name] ? values[s.name][s.options.track] : undefined
            break;
        case 'masked':
            val =  values[s.name] ? values[s.name].replaceAll(" ","").replace("(","").replace(")","") : '';
            break
        case 'multiInput':
            let maskedNames = []
            let selectNames = []
            let selectTrackId = []
            let selectDataName = []
            s.inputs.map(i => {
                selectDataName.push(i.modal[0])
                if(i.type == 'masked')
                    maskedNames.push(i.name)
                else if(i.type == 'select'){
                    selectNames.push(i.name)
                    selectTrackId.push(i.options.track)
                }
            })
            if(maskedNames.length > 0 || selectNames.length > 0){
                values[s.name].map((v,i) => {
                    console.log(v, s.name, values[s.name], selectTrackId, selectNames)
                    selectDataName.map((VElement,j) => {
                        if(maskedNames.includes(VElement))
                            values[s.name][i][VElement] = values[s.name][i][VElement].replaceAll(" ","").replace("(","").replace(")","")
                        if(selectNames.length > 0 && s.inputs[j].type == 'select')
                            values[s.name][i][VElement] = v[s.inputs[j].modal[0]][selectTrackId]
                    })
                })
            }
            val = values[s.name];
            break;
        case 'grid':
            if(s.modal[0])
                val = values[s.name][0][s.data[0]];
            else
                val = values[s.name][0];        
            break;
        default:
            val = values[s.name];
            break;
    }
    return val
}

export const sendRequestList = async (schema, thisRef) => {
    let data = {}
    if(thisRef.$route.params.id)
        data.parent_id = thisRef.$route.params.id
    schema && schema.map(async s => {
        switch(s.type){
            case 'select':
                _.merge(data, s.params)
                if(s.beforeField && thisRef.formData && (thisRef.formData[s.beforeField] !== null && thisRef.formData[s.beforeField] !== undefined)){
                    let beforeField = s.beforeField
                    let params = []

                    while(beforeField !== undefined){
                        let bF = schema.find(e => e.name == beforeField)
                        if(bF){
                            params.push(thisRef.formData[beforeField][bF.options.track])
                            beforeField = bF.beforeField
                        }else
                            break;
                    }
                    s.options.type !== 'locale' && await thisRef.$store.dispatch(s.name.toLowerCase()+'_list', params.reverse())
                }
                else if(!s.beforeField)
                    s.options.type !== 'locale' && await thisRef.$store.dispatch(s.name.toLowerCase()+'_list', data)
                break;
            case 'multiInput':
                sendRequestList(s.inputs, thisRef)
                break
        }
    })
}

export const sendRequest = async (thisRef) => {
    let data = {};
    if(thisRef.$refs.modalForm.formData){
        data = prepareRequestData(thisRef.forms[thisRef.formSchema] ? thisRef.forms[thisRef.formSchema]  : thisRef.forms[thisRef.form], thisRef.$refs.modalForm.formData )
    }
    if(thisRef.$refs.modalForm.text)
            data.comment = thisRef.$refs.modalForm.text
    if(thisRef.modalProps){
        data.id = thisRef.modalProps.id ? thisRef.modalProps.id : thisRef.modalProps.ID
        data.type = thisRef.modalProps.user_type !== null ? thisRef.modalProps.user_type : undefined
    }
    data.parent_id = thisRef.$route.params.id ? parseInt(thisRef.$route.params.id) : parseInt(thisRef.modalProps.parent_id)
    if(data.customerSub)
        data.customerSub = [{sub_id: data.customerSub.sub_id, begin_date: data.customerSub.begin_date, end_date: data.customerSub.end_date  }]
    if(thisRef.modalName == 'SetState'){
        data[thisRef.modalProps.type] = thisRef.modalProps[thisRef.modalProps.type]
        await thisRef.$store.dispatch((thisRef.form+'_'+thisRef.modalProps.type).toLowerCase(), data) 
    }else{
        console.log(data)
        await thisRef.$store.dispatch((thisRef.form+'_'+thisRef.modalName).toLowerCase(), data)
    }

    return data
}

export const setFormData = (schema, values) => {
    let data = {};
    schema && schema.map(s => {
        let tmpData = values;
        console.log(values, tmpData)
        if(s.data && values){
            s.data.map( d => {
                tmpData = tmpData ? tmpData[d] : null
            })
            if(s.type == 'select' && s.options.type =='locale'){
                tmpData = s.options.data.find(e => e[s.options.track] == tmpData)
            }else if(s.type == 'masked' && tmpData && tmpData.length >= 9){
                let strArr = tmpData.split("")
                tmpData = strArr[0]+' '+strArr.slice(1,3).join('')+' ('+strArr.slice(3,6).join('')+') '+strArr.slice(6,9).join('')+' '+strArr.slice(9).join('')
            }else if(s.type == 'multiInput'){
                s.inputs.map(i => {
                    if(i.type == 'select'){
                        console.log(values, tmpData)
                        tmpData && tmpData.map((t,index) => {
                            console.log(i.options, t)
                            if(typeof t[i.data[0]]=='string'){
                                tmpData[index][i.data[0]] = {[i.options.label]: t[i.data[0]]}
                                if(i.options.key){
                                    tmpData[index][i.data[0]][i.options.key] =  t[i.options.key]
                                }

                            }
                        })
                    }
                })
            }
            tmpData = {[s.name]:(tmpData !== null && tmpData !== undefined) ? tmpData : s.default}
            _.merge(data, tmpData)
        }else{
            tmpData = {[s.name]: s.default}
            _.merge(data, tmpData)
        }
        if(s.checkBox && values){
            tmpData = values;
            s.checkBox.data && s.checkBox.data.map( d => {
                tmpData = tmpData ? tmpData[d] : null
            })
            tmpData = {[s.checkBox.name]:tmpData !== null ? tmpData : s.default}
            _.merge(data, tmpData)
        }
    })
    return data
}


export default prepareRequestData;


// WEBPACK FOOTER //
// ./src/assets/js/custom.js